import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import './style/reset.css';
import './style/client.css';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import aliplayer from 'vue-aliplayer-v2';

import VCalendar from 'v-calendar';

import Share from 'vue-social-share'
import 'vue-social-share/dist/client.css';

Vue.use(Share)

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: 'vc',
});

Vue.config.productionTip = false;

Vue.use(Antd);
Vue.use(aliplayer);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
